// @flow

// Exports
export default function floatDecoderCreator (maybePrecision: ?number): (value: mixed) => number {
  const precision = maybePrecision != null
    ? maybePrecision
    : 15

  return function floatDecoder (value: mixed): number {
    if (value != null) {
      const n: number = Number(value)

      if (isNaN(n)) {
        return 0
      }

      // $FlowFixMe
      return Number(Math.round(n + 'e' + precision) + 'e-' + precision) || 0
    }

    return 0
  }
}
